<div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Session Calendar</h3></div>
    <full-calendar [options]="calendarOptions" deepChangeDetection="true" (onchange)="changeDate()">
        <ng-template #headerToolbar>
            <div class="fc-toolbar">
                <div class="fc-left">
                    <button class="fc-button fc-prev" type="button" (click)="prev()"><span class="pi pi-chevron-left"></span></button>
                    <button class="fc-button fc-next" type="button" (click)="next()"><span class="pi pi-chevron-right"></span></button>
                </div>
                <div class="fc-center">
                    <h2>{{currentDate | date: 'MMMM yyyy'}}</h2>
                </div>
                <div class="fc-right">
                    <button class="fc-button fc-today" type="button" (click)="today()"><span i18>Today</span></button>
                </div>
                <div class="fc-right">
                    <button class="fc-button fc-add" type="button" (click)="addEvent()"><span i18>Add Event</span></button>
                </div>
                <div class="fc-right">
                    <button class="fc-button fc-refresh" type="button" (click)="refresh()"><span i18>Refresh</span></button>
                </div>
            </div>
        </ng-template>

    </full-calendar>
</div>